import { useThemes } from "../../providers/theme";
import { useMerchant } from "../../store/global/useMerchant";
import { getCurrentDepartment, getToggledTheme } from "../../services/functions";
import { MoveLeft, MoveRight } from "lucide-react";
import { motion } from "framer-motion"
import { useCallback, useState } from "react";
import { useAnimation } from "framer-motion";
import { twMerge } from "tailwind-merge";

export function ToggleDepartment() {
  const controls = useAnimation();
  const { toggleTheme } = useThemes();
  const [play, setPlay] = useState(true);

  const department = getCurrentDepartment()
  const merchant = useMerchant(st => st.data.merchant)
  const showToggle = merchant.activeModules?.['clinica-veterinaria']
  const themeToggle = useCallback(() => {
    toggleTheme(getToggledTheme())
    setPlay(true)
  }, [controls])

  if (!showToggle) return null
  const toggleHoverClass = department === 'veterinary' ? 'hover:text-[#f97b18]' : 'hover:text-[#7092d2]'
  return (
    <button
      onClick={themeToggle}
      className={twMerge(
        "py-4 px-0 relative  text-zinc-600 flex items-center justify-center flex-col transition duration-300 group",
        toggleHoverClass,
        play && "pointer-events-none"
      )}
    >
      <motion.span
        animate={play ? { x: ["0%", "-100%", "100%", "0%"], opacity: [1, 0, 0, 1] } : { x: 0, opacity: 1 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        onAnimationComplete={() => setPlay(false)}
        className="flex items-center justify-center h-2.5 group-hover:animate-rightping"
      >
        <MoveLeft className="w-6 h-6" />
      </motion.span>
      <motion.span
        animate={play ? { x: ["0%", "100%", "-100%", "0%"], opacity: [1, 0, 0, 1] } : { x: 0, opacity: 1 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="flex items-center justify-center h-2.5 group-hover:animate-leftping"
      >
        <MoveRight className="w-6 h-6" />
      </motion.span>
    </button>
  );
}
